/* eslint-disable import/prefer-default-export */
import React from 'react';
import MenuItem from 'Common/Components/ContextMenu/components/MenuItem';
import { useDispatch, useSelector } from 'react-redux';
import { saveTemplateFromVulnContext } from 'store/Manage/actions';
import { useIntl } from 'react-intl';
import { SaveTemplateIcon } from './styled';
import { showContextMenu } from 'store/Contextualization/AssetDetail/actions';
import { selectSelected } from 'store/Contextualization/AssetDetail/selectors';

export const SaveAsTemplate = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const vulnsSelected = useSelector((state) => selectSelected('vulns', state));

  return (
    <MenuItem
      title={ intl.formatMessage({ id: 'manage.cm.saveAsTemplate' }) }
      icon={ <SaveTemplateIcon /> }
      onClick={ () => {
        dispatch(saveTemplateFromVulnContext(vulnsSelected, 'vulnsAssets'));
        dispatch(showContextMenu(false));
      } }
    />
  );
};
